import { NgModule } from '@angular/core';
import { ChipModule } from 'primeng/chip';
import { ChipComponent } from './chip.component';
import { CommonModule } from '@angular/common';
import { TypographyComponentModule } from '../typography/typography.module';
import { PipesModule } from '../../../pipes/pipes.module';

@NgModule({
  declarations: [ChipComponent],
  imports: [CommonModule, ChipModule, TypographyComponentModule, PipesModule],
  exports: [ChipModule, ChipComponent],
})
export class ChipComponentModule {}
